<template>
  <div class="rt60">
    <!-- <top-nav></top-nav> -->
    <banner :child-data="fdata"></banner>
    <div id="join-main" class="bgrow " data-ani="">
      <div class="container">
        <div class="row">
          <div class="col-md-6 df mr20">
            <div class="box_shadow">
              <img class="w20" src="img/join_us/job-social.png" alt />
              <div class="pull-right">
                <b-link
                  :to="{path:'/joinUsDetail',query:{
                    cate:'school'
                }}"
                  class="spandf"
                >
                  <!-- <a href="./join_social.html?cate=school_en" class="spandf"> -->
                  <span>{{$t('JoinSecH0')}}</span>
                  <span>{{$t('JoinSecBtn')}}</span>
                  <!-- </a> -->
                </b-link>
              </div>
            </div>
          </div>
          <div class="col-md-6 df mr20 " data-ani="">
            <div class="box_shadow">
              <img class="w20" src="img/join_us/job-social.png" alt />
              <div class="pull-right">
                <b-link
                  :to="{path:'/joinUsDetail',query:{
                    cate:'socail'
                }}"
                  class="spandf"
                >
                  <!-- <a href="./join_social.html?cate=social_en" class="spandf"> -->
                  <span>{{$t('JoinSecH1')}}</span>
                  <span>{{$t('JoinSecBtn')}}</span>
                  <!-- </a> -->
                </b-link>
              </div>
            </div>
          </div>
        </div>

        <div class="row  " data-ani="">
          <h3 class="text-center" style="width:100%">{{$t('JoinTitle')}}</h3>
          <p class="text-center">{{$t('JoinP')}}</p>
        </div>

        <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="4000"
          controls
          indicators
          background="#ababab"
          img-width="1024"
          img-height="480"
          style="text-shadow: 1px 1px 2px #333;"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <b-carousel-slide img-src="img/join_us/5.jpg"></b-carousel-slide>
          <b-carousel-slide img-src="img/join_us/1.jpg"></b-carousel-slide>

          <b-carousel-slide img-src="img/join_us/3.jpg"></b-carousel-slide>
        </b-carousel>
      </div>
    </div>
    <!-- <footer-bot></footer-bot> -->
  </div>
</template>

<script>
import topNav from "../components/top";
import banner from "../components/banner";
import footerBot from "../components/footerBot";
import { mapMutations } from "vuex";
export default {
  name: "joinUs",
  data() {
    return {
      fdata: {
        h1: "Join Us",
        h2: "Do something that is changing humanity",
        style: {
          background: "url(../img/join_us/banner-joinus.jpg) no-repeat center",
          backgroundSize: "100% 100%"
        }
      },
      slide: 0,
      sliding: null
    };
  },
  components: {
    topNav,
    banner,
    footerBot
  },
  methods: {
    ...mapMutations(["editMenu"]),
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    }
  },
  mounted() {
    this.editMenu("joinUs");
  }
};
</script>

<style>
#join-main {
  padding-bottom: 30px;
}

#headerwrap {
  display: flex;
  align-items: center;
  justify-content: center;
}

#headerwrap h1 {
  margin-top: 0;
}

#headerwrap h2 {
  color: white;
  margin-bottom: 0;
}

#join-main .img-banner h3 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
}

@media screen and (max-width: 480px) {
  #join-main .img-banner {
    height: 170px;
    width: 100%;
    background: url(../../public/img/product/cpzx_banner@3x.jpg) no-repeat
      center;
    background-size: 100% 100%;
  }
}

#join-main .company-info {
  padding: 80px 0px;
  box-sizing: border-box;
}

#join-main .info-title,
#join-main .develop-title {
  text-align: center;
  margin-bottom: 30px;
}

#join-main .info-main {
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
}

#join-main .info-main img {
  width: 100%;
}

#join-main .info-title .title-text,
#join-main .develop-title .title-text {
  font-size: 30px;
}

.bgrow {
  background: url(../../public/img/join_us/bg-diwen.svg) no-repeat center top;
  background-size: 100%;
}
.box_shadow {
  height: 180px;
  box-shadow: 0 5px 30px 0 rgba(77, 138, 221, 0.15);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 80px 0px;
  padding-bottom: 0;
  background-clip: content-box;
}

.spandf {
  display: flex;
  flex-direction: column;
  line-height: 40px;
  font-size: 20px;
  margin-left: 30px;
}
.spandf span {
  text-align: left;
}
.spandf span:nth-child(1) {
  font-weight: 600;
}

.spandf span:nth-child(2) {
  font-size: 16px;
}
.w20 {
  width: 25%;
}
.rt60 {
  position: relative;
  top: -60px;
    margin-bottom: -60px;
}
</style>